import { Control, FieldPath, FieldValues } from 'react-hook-form';
import { ControlledCheckbox } from '../../../../controlled/ControlledCheckbox';
import { Label } from './styled';

type OptionProps<T extends FieldValues> = {
  control: Control<T>;
  children: string;
  controller: FieldPath<T>;
} & FieldValues;

export const Option = <T extends FieldValues>({ children, control, controller }: OptionProps<T>) => {
  return (
    <ControlledCheckbox
      variant="outlined"
      size="md"
      control={control}
      controller={controller}
      label={<Label>{children}</Label>}
    />
  );
};
